import { render, staticRenderFns } from "./UpdateBillingInfo.vue?vue&type=template&id=055d2178"
import script from "./UpdateBillingInfo.vue?vue&type=script&lang=js"
export * from "./UpdateBillingInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateBillingInfo.vue?vue&type=style&index=0&id=055d2178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports